import React, {useEffect, useState} from "react"
import LocationSelector from './LocationSelector'
import LocationDisplay from './LocationDisplay'

const W2S = () => {

	const [diveRegions, setDiveRegions] = useState(null)
	const [diveSites, setDiveSites] = useState([])
	const [regionSelectorData, setRegionSelectorData] = useState([])
	const [checked, setChecked] = useState([])

	useEffect(() => {
		const analyzeDiveData = (data) => {
			const regions = []
			const sites = data.DiveLocations
			const leaf = []
			// console.log('Data:', data)
			data.DiveRegions.forEach((location, index) => {
				const newObj = {
					value: location.id,
					label: location.description,
					level: location.level,
					parent: location.parent
				}
				if (newObj.level === "1")  {
					newObj.children = []
					regions.push(newObj)
				} else {
					// Only include locations with sites
					if (sites.some(e => e.dive_region === newObj.value))
						leaf.push(newObj)
				}
			})
			leaf.forEach((location, index) => {
				var i = regions.map(function(e) {return e.value}).indexOf(location.parent)
				regions[i].children.push(location)
			})
			// Only include regions that have children
			setDiveRegions(regions.filter(el => el.children.length > 0))
			setDiveSites(sites)
		}
		const getDiveData = async () => {
			const reqUrl = 'https://my.snuba.com/api/diveplugin.php?a=divedata'
			const response = await fetch(reqUrl)
			const responseData = await response.json()
			analyzeDiveData(responseData)
		}
		getDiveData()
	},[])

	return (
		<div class='w2sMain'>
			<LocationSelector 
				regionSelectorData={diveRegions}
				checked={checked}
				setChecked={setChecked}
			/>
			<LocationDisplay
				siteData={diveSites.filter(el => checked.includes(el.dive_region))}
			/>
		</div>
	)
}

export default W2S
